import { render, staticRenderFns } from "./UpScroll.vue?vue&type=template&id=03b62092&scoped=true&"
import script from "./UpScroll.vue?vue&type=script&lang=js&"
export * from "./UpScroll.vue?vue&type=script&lang=js&"
import style0 from "./UpScroll.vue?vue&type=style&index=0&id=03b62092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b62092",
  null
  
)

export default component.exports